<template>
  <div>
    <div class="headerimg">
      <img :src="bannerImg" alt="" v-if="bannerImg">
    </div>
    <div class="headertitle">
      <h2>品牌介绍</h2>
    </div>

    <div class="onecon">
      <div class="onetit">品牌定位</div>
      <img :src="dingwei.m_content" alt="">
    </div>

    <div class="onecon">
      <div class="onetit">品牌风格</div>
      <img :src="fengge.m_content" alt="">
    </div>

    <div class="onecon">
      <div class="onetit">品牌理念</div>
      <img :src="linian.m_content" alt="">
    </div>

    <div class="onecon">
      <div class="onetit">人群定位</div>
      <img :src="renqun.m_content" alt="">
    </div>

    <div class="onecon1">
      <div>
        <div>
          <p v-html="dazao.btitle"></p>
          <div class="line"></div>
        </div>
        <img :src="dazao.m_poto" alt="">
      </div>
      <img :src="dazao.m_content" alt="">
    </div>

    <!-- <div>华帝家居布局中国</div> -->
    <img :src="buju.m_poto" alt="">
    <!-- <img :src="buju.m_content" alt=""> -->
    <div class="longbg3">
      <h5 class="texthan" v-html="bujutext.texthan"></h5>
      <div class="textline"></div>
      <p class="textsmall" v-html="bujutext.textsmall"></p>
    </div>

    <join-zhuce></join-zhuce>
    <v-bottom></v-bottom>
  </div>
</template>

<script>
import joinZhuce from '@/components/Join.vue'
import vBottom from '@/components/Bottom.vue'
import { joiusbrand, joiusbrand2, banner } from '@/api'
export default {
  name: 'brand',
  components: {
    joinZhuce,
    vBottom
  },
  data () {
    return {
      bannerImg: '',
      dingwei: {},
      fengge: {},
      linian: {},
      renqun: {},
      dazao: {},
      buju: {},
      bujutext: {}
    }
  },
  methods: {
    tolist () {
      joiusbrand().then(res => {
        if (res.status === 1) {
          res.msg.map(item => {
            if (item.id === 1) {
              // 品牌介绍
            } else if (item.id === 2) {
              // 品牌定位
              this.dingwei = item
            } else if (item.id === 4) {
              // 品牌风格
              this.fengge = item
            } else if (item.id === 5) {
              // 品牌理念
              this.linian = item
            } else if (item.id === 7) {
              // 人群定位
              this.renqun = item
            } else if (item.id === 9) {
              // 华帝家居打造舒适家居生活
              item.btitle = item.btitle.replace(/\n/g, '<br>')
              this.dazao = item
            } else if (item.id === 11) {
              // 华帝家居布局中国
              this.buju = item
            }
          })
        }
      })
      joiusbrand2().then(res => {
        if (res.status === 1) {
          this.bujutext.texthan = res.msg[6].btitle
          this.bujutext.textsmall = res.msg[6].t_content
          this.bujutext.textsmall = this.bujutext.textsmall.replace(/\n/g, '<br>')
        }
      })
      banner(32).then(res => {
        if (res.status === 1) {
          this.bannerImg = res.msg
        }
      })
    }
  },
  created () {
    this.tolist()
  }
}
</script>

<style lang="scss" scoped>
.onecon {
  position: relative;
  padding-top: 0.4rem;
  margin-top: 0.8rem;
  .onetit {
    width: 3rem;
    height: 0.8rem;
    font-size: 0.36rem;
    color: #fff;
    background-color: #005644;
    line-height: 0.8rem;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}
.onecon1 {
  margin-top: 0.4rem;
  >div:nth-of-type(1) {
    position: relative;
    padding-top: 0.4rem;
    margin-bottom: 1rem;
    >div:nth-of-type(1) {
      position: absolute;
      left: 0.8rem;
      top: 2rem;
      width: 3rem;
      height: 3.2rem;
      color: #fff;
      background: rgba(0,91,71,0.8);
      font-size: 0.36rem;
      padding: 0.4rem;
      line-height: 0.5rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .line {
        width: 1.6rem;
        height: 1px;
        background-color: #fff;
        margin-top: 0.4rem;
        margin-bottom: 0.2rem;
      }
    }
  }
}
.longbg3 {
  background-color: #d1d1d1;
  box-sizing: border-box;
  padding: .6rem .3rem;
  text-align: center;
  .texthan {
    font-size: .56rem;
    color: #085f4c;
  }
  .textying {
    font-size: .24rem;
    font-weight: 500;
    color: #085f4c;
  }
  .textsmall {
    font-size: .2rem;
    color: #808080;
    letter-spacing: 2px;
    line-height: .3rem;
  }
  .textline {
    width: 40%;
    height: 1px;
    background: #085f4c;
    margin: .4rem auto;
  }
}
</style>
